import React from "react";
import SvgMapper from "../../features/common/SvgMapper";

const SystemCheck = ({ checks }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4 mt-4">
      <h4 className="font-medium text-gray-900 mb-3">System Check</h4>

      <div className="space-y-2">
        {checks.map((check, index) => {
          const isReady = check.status === "Ready";
          const isNotStarted = check.status === "Not Started";
          const isError = check.status === "Error";
          
          let statusColor = "text-gray-600";
          let iconColor = "text-gray-600";
          
          if (isReady) {
            statusColor = "text-green-600";
            iconColor = "text-green-600";
          } else if (isNotStarted) {
            statusColor = "text-red-600";
            iconColor = "text-red-600";
          } else if (isError) {
            statusColor = "text-red-600";
            iconColor = "text-red-600";
          }
          
          return (
            <div key={index} className="flex items-center justify-between">
              <span className="text-sm text-gray-600">{check.label}</span>
              <div className="flex items-center space-x-2">
                {isReady ? (
                  SvgMapper.checkCircle(`w-5 h-5 ${iconColor}`)
                ) : isNotStarted || isError ? (
                  SvgMapper.closeIcon(`w-5 h-5 ${iconColor}`)
                ) : (
                  SvgMapper.checkCircle(`w-5 h-5 ${iconColor}`)
                )}
                <span className={`text-sm ${statusColor}`}>{check.status}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SystemCheck;

